import {axios as http} from "@/plugins/http";

export default class Api {
    static bindCategory(postId, items) {
        return http.post("/api/v1/post/mark-ad-auto/bind-category", {
            "post_id": postId,
            "items": items,
        }).then((resp) => {
            return resp.data
        })
    }

    static erid(postId, items) {
        return http.post("/api/v1/post/mark-ad-auto/erid", {
            "post_id": postId,
            "items": items,
        }).then((resp) => {
            return resp.data
        })
    }

    static getPost(postId) {
        return http.post("/api/v1/post/mark-ad-auto/get-post", {
            "post_id": postId,
        }).then((resp) => {
            return resp.data
        })
    }
}
